import React from 'react';
import { Square, Row, Column, Copy } from '@grubhubprod/gh-cookbook-react/dist';
import { ColumnWidths } from 'src/components/enterprise/features/TaxExemptions/ExemptionCertificateList/tableSpacing';
import { SortableColumn } from 'src/components/Table/SortableColumn';
import { SortConfig } from 'src/components/enterprise/features/TaxExemptions/ExemptionCertificateList/sortConfiguration';
import { CertificateAttribute } from 'src/types/TaxExemptionCertificate';

export type ExemptionCertificatesTableHeaderProps = {
  sortBy: (sortField: CertificateAttribute) => void;
  sortConfig: SortConfig;
};

export default function ExemptionCertificatesTableHeader({
  sortBy,
  sortConfig,
}: ExemptionCertificatesTableHeaderProps): JSX.Element {
  return (
    <Square>
      <Row gutter={0}>
        <Column gutter={0} phone={ColumnWidths.name}>
          <div aria-label="Name column">
            <Copy variant="body" color="secondaryText">
              Name
            </Copy>
          </div>
        </Column>
        <Column gutter={0} phone={ColumnWidths.state}>
          <div aria-label="State column">
            <SortableColumn
              label="State"
              previousSortOrder={sortConfig.previousSortOrder}
              sortField={CertificateAttribute.state}
              previousSortField={sortConfig.previousSortField}
              onSortColumnClick={() => sortBy(CertificateAttribute.state)}
            />
          </div>
        </Column>
        <Column gutter={0} phone={ColumnWidths.status}>
          <div aria-label="Status column">
            <SortableColumn
              label="Status"
              previousSortOrder={sortConfig.previousSortOrder}
              sortField={CertificateAttribute.status}
              previousSortField={sortConfig.previousSortField}
              onSortColumnClick={() => sortBy(CertificateAttribute.status)}
            />
          </div>
        </Column>
        <Column gutter={0} phone={ColumnWidths.expiration}>
          <div aria-label="Expires column">
            <SortableColumn
              label="Expires"
              previousSortOrder={sortConfig.previousSortOrder}
              sortField={CertificateAttribute.expirationDate}
              previousSortField={sortConfig.previousSortField}
              onSortColumnClick={() =>
                sortBy(CertificateAttribute.expirationDate)
              }
            />
          </div>
        </Column>
      </Row>
    </Square>
  );
}
